import type { FlagCategory } from "@/types/api/enums";
import { Chip } from "@mui/material";

const flagCategoryColor = Object.freeze({
  10: "default", // YEAR
  20: "info", // MODULE
  30: "success", // LABORATORY
  40: "warning", // CAMPAIGN
  50: "error", // LABORATORY_USER
  60: "primary", // PARTICIPANT
});

type FlagsCategoryChipProps = {
  category: FlagCategory | string;
  size?: "smaller" | "small" | "medium";
}

const FlagsCategoryChip = ({
  category,
  size = "small",
}: FlagsCategoryChipProps) => {
  if (typeof category === "string") {
    return (
      <Chip
        label={category}
        color="secondary"
        variant="filled"
        size={size === "smaller" ? "small" : size}
        sx={{
          ...(size === "smaller" && {
            fontSize: 11
          })
        }}
      />
    );
  }

  const color =
    flagCategoryColor[category.value as keyof typeof flagCategoryColor];

  return (
    <Chip
      label={category.label}
      color={color}
      variant="filled"
      size={size === "smaller" ? "small" : size}
      sx={{
        ...(size === "smaller" && {
          fontSize: 11
        })
      }}
    />
  );
};

export default FlagsCategoryChip;
